import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  DialogTitle: {
    wordBreak: 'break-all',
    ...theme.typography.h4,
    fontWeight: 500,
    '& span': {
      fontWeight: 700,
      color: theme.palette.primary.main
    },
    marginBottom: 16
  },
  DialogSubtitle: {
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
    fontWeight: 400,
    wordBreak: 'break-all',
    marginBottom: 50
  },
  button: {
    height: 48,
    '&:first-child': {
      marginBottom: 10
    }
  }
}));

export default useStyles;
